import { Component, Vue } from "vue-property-decorator";
import { checkRight } from "@/api/course";
import { orderCreate, OrderCreateParams } from "@/api/order";

@Component
export default class QuickOrder extends Vue {
    mounted() {
        const productId = Number(this.$route.params.productId);
        if (productId) {
            // 检验是否已购买
            checkRight(productId).then(res => {
                // 未购买则创建订单
                if (!res.data) {
                    const orderParams: OrderCreateParams = {
                        orderProducts: [{ productId: productId }],
                        appName: ""
                    };
                    orderCreate(orderParams).then(res => {
                        // 创建订单后跳转订单页
                        let orderId = res.data.id;
                        window.location.href = "/order/" + orderId;
                    });
                } else {
                    // 已购买跳转我的教室
                    window.location.href = "/myRoom";
                }
            });
        } else {
            // 参数缺失跳转首页
            window.location.href = "/";
        }
    }
}
// @ts-ignore
export { default as QuickOrder } from "./index.vue";
